import './App.scss';
import '../../styles/type.scss';
import NavHeader from '../NavHeader/navheader';
import Footer from '../Footer/footer';
import { Col, Row, Container } from 'react-bootstrap';
import { Routes, Route } from 'react-router-dom';
import Banner from '../Banner/banner';
import NotFound from '../NotFound/notfound';
import Gallery from '../Gallery/gallery';
import Logo from "../Logo/logo";
import Quad from '../Quad/quad';
import ServiceCards from '../ServiceCards/servicecards';
import Under from '../../images/Woolwax-logo.png';
import TestButton from '../TestButton/testbutton';

function App() {
  return (
      <>
        <Routes>
          <Route path="/" element={
            <>
              <NavHeader />
              <main>
                <section id='welcome'>
                  <Container fluid>
                    <Container>
                      <Row>
                        <Col>
                          <Banner style={{ flexDirection: 'column' }}>
                          <a
                                href="#"
                                aria-label="Back to top of page"
                                className="navbar-brand logo"
                                id="logo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                }}
                            >
                                <Logo />
                            </a>
                            <h1>Professional Rust Protection</h1>
                          </Banner>
                        </Col>
                      </Row>
                    </Container>
                  </Container>
                </section>
                <section id="summary">
                  <Container fluid>
                      <Container>
                          <Row>
                              <Col xs={12}>
                                  <h2>Protect your vehicle from rust—without ever leaving your driveway.</h2>
                                  <p>Our mobile undercoating service brings <strong>professional-grade rust protection</strong> straight to your home or place of business anywhere New Hampshire. We use <strong>Woolwax</strong>, an environmentally friendly, long-lasting undercoating that keeps your vehicle protected for up to two full years.</p>
                              </Col>
                          </Row>
                      </Container>
                  </Container>
                </section>
                <Quad />
                <section id="services" className='cardServices'>
                    <Container fluid>
                      <Container>
                          <Row>
                              <Col xs={12} lg={4}>
                                <ServiceCards title="Woolwax Undercoating">
                                  <img src={Under} alt='Woolwax Undercoating logo' />  
                                  <p>The most trusted name in vehicle undercoating protection.</p>
                                  <p>Two color options:</p>
                                    <ul>
                                      <li>Black undercoating for a clean, traditional finish</li>
                                      <li>Straw (clear) undercoating, great for new vehicles</li>
                                    </ul>
                                </ServiceCards>
                              </Col>
                              <Col xs={12} lg={4}>
                                <ServiceCards title="Full Mobile Service">
                                    <p>Providing service throughout New Hampshire. Working with individuals and business fleets.</p>
                                    <p>Full Undercarriage Prep:</p>
                                    <ul>
                                      <li>Frame scraping</li>
                                      <li>Grinding when needed</li>
                                      <li>Surface cleaning for maximum adhesion</li>
                                    </ul>
                                    <p style={{marginTop: '1.5rem'}}>Clean Application:</p>
                                    <ul>
                                      <li>No dripping</li>
                                      <li>No driveway stains</li>
                                      <li>No strong odor</li>
                                    </ul>
                                </ServiceCards>
                              </Col>
                              <Col xs={12} lg={4}>
                                <ServiceCards title="Undercoating Pricing">
                                  <ul>
                                    <li>$500 per vehicle</li>
                                    <li>
                                      <p>$400 per vehicle for multiple cars at the same location</p>
                                      <p>Perfect for families with multiple vehicles or small fleets.</p>
                                      <p className='small'>(Additional fee may apply based on travel time.)</p>
                                    </li>
                                  </ul>
                                  <TestButton
                                    style={{ width: '100%', justifyContent: 'center'}}
                                    variant="primary"
                                    onClick={() => {
                                      window.location.href = 'tel:603-770-2677'; // Open phone dialer with the number
                                    }}
                                  >
                                    CALL 603-770-2677
                                  </TestButton>
                                </ServiceCards>
                              </Col>
                          </Row>
                      </Container>
                    </Container>
                </section>
                <Gallery />
              </main>
            </>
          } />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </>
  );
}

export default App;